import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { subscribersUrl } from '@/constants/urls';
import { subscribersIcon } from '../constants';

const SubscribersPanelHeader = ({
  category,
  code,
  value,
  className,
  isLoading,
}) => {
  const intl = useIntl();
  if (!value) {
    return null;
  }

  const icon = isLoading ? 'circle notch' : subscribersIcon(category);
  return (
    <Header
      as="a"
      href={subscribersUrl(category, code, '#')}
      className={clsx('aridhia-subscribers-panel-header primary aridhia-h2', className)}
      rel="noopener noreferrer"
    >
      <Icon loading={isLoading} name={icon} color="blue" />
      <Header.Content content={intl.formatMessage({ id: 'tabs.subscribers.to' }, { name: value })} />
    </Header>
  );
};

export default SubscribersPanelHeader;
